import { ClientDestinationsModel } from '../../../api/hooks/useDestinations';

export interface ValidationError {
  key: string;
  params: Record<string, string>;
}

export function validateClientDestinationsModel(
  model: ClientDestinationsModel
): Map<string, Array<ValidationError>> {
  const errorsByDestinationId: Map<string, Array<ValidationError>> = new Map<
    string,
    Array<ValidationError>
  >();

  model.organizationalUnitDtos.forEach((orgUnit) => {
    orgUnit.destinationDtos.forEach((destination) => {
      const errors: Array<{ key: string; params: Record<string, string> }> = [];
      const identifiers = destination.publicServiceTypeDto.map(
        (pst) => pst.identifier
      );
      const uniqueIdentifiers = new Set(identifiers);

      if (!orgUnit.name.trim()) {
        errors.push({
          key: 'destinations.validation.empty_name',
          params: {
            ouName: orgUnit.nameInFitConnect,
            destinationId: destination.destinationId
          }
        });
      }

      if (identifiers.length !== uniqueIdentifiers.size) {
        const duplicates = identifiers.filter(
          (item, index) => identifiers.indexOf(item) !== index
        );
        errors.push({
          key: 'destinations.validation.duplicate_identifiers',
          params: {
            ouName: orgUnit.name,
            destinationId: destination.destinationId,
            duplicateIdentifiers: duplicates.join(', ')
          }
        });
      }

      destination.publicServiceTypeDto.forEach((pst) => {
        pst.submissionSchemaDtos.forEach((schema) => {
          if (!schema.schemaUri.startsWith('https://')) {
            errors.push({
              key: 'destinations.validation.invalid_uri_protocol',
              params: {
                ouName: orgUnit.name,
                destinationId: destination.destinationId,
                identifier: pst.identifier,
                schemaUri: schema.schemaUri
              }
            });
          }

          if (schema.mimeType !== 'application/json') {
            errors.push({
              key: 'destinations.validation.invalid_mime_type',
              params: {
                ouName: orgUnit.name,
                destinationId: destination.destinationId,
                identifier: pst.identifier,
                mimeType: schema.mimeType
              }
            });
          }
        });
      });
      if (errors.length > 0) {
        errorsByDestinationId.set(destination.destinationId, errors);
      }
    });
  });

  return errorsByDestinationId;
}
